/* @flow */
import React, { Component, PropTypes } from 'react';

export class Tooltip extends Component {
  state = {
    left: null,
    top: null,
  }

  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    color: PropTypes.string,
    getTargetRect: PropTypes.func,
    placement: PropTypes.oneOf(['bottom', 'top', 'left', 'right']),
    style: PropTypes.any,
  }

  static defaultProps = {
    className: '',
    placement: 'top',
  }

  componentDidMount() {
    if (this.props.getTargetRect) {
      this.setArrowOffset()
    }
  }

  setArrowOffset() {
    const rect = this.props.getTargetRect()
    if (this.props.placement === 'top' || this.props.placement === 'bottom') {
      this.setState({ left: rect.left + rect.width / 2 })
    } else {
      this.setState({ top: rect.top + rect.height / 2 })
    }
  }

  render() {
    let className = `tooltip ${this.props.className}`

    if (this.props.color) {
      className += ` m-${this.props.color}`
    }

    if (this.props.placement) {
      className += ` m-${this.props.placement}`
    }

    const arrowStyle = this.state.left !== null ? { left: this.state.left - this.props.style.left } : { top: this.state.top - this.props.style.top }

    return (
      <div className={className} style={this.props.style}>
        <div className="tooltip--inner">
          {this.props.children}
        </div>
        <div className="tooltip--arrow" />
      </div>
    )
  }
}
